import { z } from "zod";

export const PermitStatuses = ["Approved", "Pending", "Withdrawn", "Rejected", "Uncategorized"] as const;
export const PermitStatusSchema = z.enum(PermitStatuses);

export type PermitStatus = z.infer<typeof PermitStatusSchema>;
